import { SIZE_SELECT_ERROR } from "../../constants";

export const clearSizeSelectError = () => dispatch => {
  dispatch({
    type: SIZE_SELECT_ERROR,
    payload: { itemId: null }
  });
};
